import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import * as apiMenu from "../../../../api/apiMenu"
import * as Auth from "../../../Login/Auth"
import { MHeader } from "./MenuTable"
import { ContentBox } from '../../Content/ContentBox';
import { ReqPage } from '../../../../item/ItemPage';


//當我們宣告一個組件時，名稱第一字母必須大寫，這很重要ㄛ
export function AdminPageAdd(props) {

    const [menuItems, setMenuItems] = useState([]);
    const [pageName, setPageName] = useState("");
    const [pageDescription, setPageDescription] = useState("");
    const [pageLink, setPageLink] = useState("");
    const [menuId, setMenuId] = useState("");

    const [pageList, setPageList] = useState([]);


    function getMenu() {
        var token = Auth.getToken();
        //console.log("token");
        //console.log(token);
        apiMenu.getRealMenu({
            success: (obj, menuItems) => {
                console.log(obj)
                console.log(menuItems)
                var menuList = [];
                obj.menus.forEach(result => {
                    menuList.push(result);
                });
                setMenuItems(menuItems);
            },
            failure: (err) => {

            }
        })
    }

    function getPageList() {
        apiMenu.getPageRealList({
            success: (obj) => {
                console.log(obj)
                setPageList(obj.pages)
            },
            failure: (err) => {

            }
        })
    }

    useEffect(() => {
        if (menuItems.length === 0) {
            getMenu();
        }
        return () => {
        }
    }, [menuItems,])

    useEffect(() => {
        if (pageList === undefined || pageList.length === 0) {
            getPageList();
        }
        return () => {
        }
    }, [pageList])

    //console.log(menuItems)

    function addPage() {
        var mReqPage = new ReqPage({
            pageName, pageDescription, pageLink, menuId
        })
        // console.log(mReqPage)
        if (pageName !== "" && pageDescription !== "" && menuId !== "") {
            apiMenu.addPage({
                mReqPage, 
                success: (status) => {
                    Swal.fire({
                        type: 'success',
                        title: '提醒',
                        text: '新增成功',
                    })
                    setPageName("")
                    setPageDescription("")
                    setPageLink("")
                    setMenuId("")
                    getPageList();
                },
                failure:()=>{
                    Swal.fire({
                        type: 'error',
                        title: '提醒',
                        text: '新增失敗',
                    })
                }
            })
        } else {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: '新增失敗',
            })
        }
    }

    if (menuItems === "" || menuItems.length === undefined)
        return (<></>)
    else {
        const divStyle={
            overflowY: 'scroll',
            border:'1px solid green',
            //width:'500px',
            float: 'left',
            height:'500px',
            position:'relative'
          };
          
        var title = "頁面新增"
        var content =
            <div className="row">
                <div className="col-sm-8" style={divStyle}>
                    <div className="box box-primary">
                        <div className="box-header">
                            <ol>
                                {
                                    menuItems.map((item, index) => (
                                        <MHeader key={"MH_" + index + item.menuId} item={item} pageList={pageList} />
                                    ))
                                }
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4">
                    <div className="box box-danger">
                        <div className="box-header with-border">
                            <div className="form-group">
                                <label htmlFor="pageName">頁面名稱</label>
                                <input type="text" className="form-control" id="pageName" placeholder="" value={pageName} onChange={e => setPageName(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="pageDescription">頁面說明</label>
                                <input type="text" className="form-control" id="pageDescription" placeholder="" value={pageDescription} onChange={e => setPageDescription(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="pageLink">頁面連結</label>
                                <input type="text" className="form-control" id="pageLink" placeholder="請輸入連結網址" value={pageLink} onChange={e => setPageLink(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="menuId">上層menuId</label>
                                <input type="text" className="form-control" id="menuId" placeholder="參考左邊列表" value={menuId} onChange={e => setMenuId(e.target.value)} />
                            </div>
                        </div>
                        <div className="box-footer">
                            <button type="submit" className="btn btn-primary" onClick={addPage}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        // console.log(menuItems)
        return (
            <ContentBox title={title}  content={content}  hasDrawer={true} />
    
        )
    }
}